import React from "react"
import ScriptTagBlock from "../shared/ScriptTagBlock.jsx"

function formatDate(iso) {
  if (!iso) return ""
  try {
    const d = new Date(iso)
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
  } catch {
    return ""
  }
}

export default function ScriptPage({ t, shopState }) {
  const shop = shopState.shop
  const apiKey = shop?.api_key
  const installed = !!shop?.script_installed

  return (
    <div className="space-y-8">
      <header>
        <p
          className="font-mono text-[10px] text-ai mb-3"
          style={{ letterSpacing: "0.15em", fontVariantNumeric: "tabular-nums" }}
        >
          {t("dashboard.script.eyebrow")}
        </p>
        <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
          {t("dashboard.script.title")}
        </h1>
        <p className="mt-3 text-sm text-ink-secondary max-w-2xl" style={{ lineHeight: 1.55 }}>
          {t("dashboard.script.lede")}
        </p>
      </header>

      <ScriptTagBlock t={t} apiKey={apiKey} />

      <div
        className={`flex items-center justify-between gap-4 rounded-card border p-4 ${
          installed ? "border-rule bg-winner-fill" : "border-rule bg-surface-subtle"
        }`}
      >
        <div className="flex items-center gap-3">
          <span
            aria-hidden
            className={`inline-block w-[8px] h-[8px] rounded-full ${installed ? "" : "animate-pulse"}`}
            style={{ background: installed ? "var(--color-winner-dot)" : "var(--color-ai)" }}
          />
          <span
            className="text-[13px] font-medium"
            style={{ color: installed ? "var(--color-winner)" : "var(--color-ink-secondary)" }}
          >
            {installed
              ? t("dashboard.script.status_installed", { date: formatDate(shop?.created_at) })
              : t("dashboard.script.status_waiting")}
          </span>
        </div>
      </div>

      <section className="space-y-3">
        <h2
          className="font-mono text-[10px] text-ink-tertiary"
          style={{ letterSpacing: "0.12em" }}
        >
          {t("dashboard.script.troubleshooting_eyebrow")}
        </h2>
        <p className="text-[13px] text-ink-secondary" style={{ lineHeight: 1.55 }}>
          {t("dashboard.script.troubleshooting_body", { head: "<head>" })}
        </p>
      </section>
    </div>
  )
}
